import React from 'react'

import { Button } from 'src/components/Button/Button'
import { ErrorIcons } from 'src/enums/ErrorIcons'
import { AlertSign, ErrorSign, H1, InfoSign, PMedium } from 'src/styles/commons'
import { Icons } from 'src/utils/icons'
import { useTheme } from 'styled-components'

import { BtnBack, Container, Content, ErrorContainer } from './ErrorPage.styles'

interface ErrorPage {
  title: string | JSX.Element
  subTitle: string | JSX.Element
  nameButton?: string
  icon?: string
  disabledButton?: boolean
  goHome: () => void
  done: () => void
}

export const ErrorPage: React.FC<ErrorPage> = ({
  title,
  subTitle,
  nameButton,
  icon,
  disabledButton,
  goHome,
  done,
}) => {
  const theme = useTheme()

  const errorIcon = <Icons.Canceled width={32} height={32} color={theme.colors.base.white} />
  const reuseIcon = <Icons.Reuse width={32} height={32} color={theme.colors.base.white} />
  const homeIcon = <Icons.Home color={theme.colors.primary.A500} />
  const cameraIcon = <Icons.Camera color={theme.colors.primary.A500} />

  const renderIcon = () => {
    let fill: React.ReactElement

    switch (icon) {
      case ErrorIcons.CAMERA:
        fill = <InfoSign>{cameraIcon}</InfoSign>
        break
      case ErrorIcons.UPDATE:
        fill = <AlertSign>{reuseIcon}</AlertSign>
        break
      default:
        fill = <ErrorSign>{errorIcon}</ErrorSign>
        break
    }

    return fill
  }

  const button = (
    <Button className="foot-button" data-testid="done-button" onClick={done}>
      {nameButton || 'Entendi'}
    </Button>
  )

  return (
    <ErrorContainer>
      <Container>
        <BtnBack
          type="button"
          onClick={goHome}
          aria-label="Botão voltar erro"
          data-testid="home-button"
        >
          {homeIcon}
        </BtnBack>
        <Content>
          {renderIcon()}
          <H1 margin="24px 0 8px">{title}</H1>
          <PMedium scale={400}>{subTitle}</PMedium>
        </Content>
        {!disabledButton && button}
      </Container>
    </ErrorContainer>
  )
}
